import React from 'react';
import { Form, Input } from 'antd';

import { BannerFormProps } from '../service/banners.interface';
import { BannerImageUpload } from './BannerImageUploader';

export const BannerForm = ({ form, isEdit, values }: BannerFormProps) => {
    return (
        <Form
            style={{
                width: 710,
            }}
            name='banner'
            form={form}
            layout={'vertical'}
            autoComplete='off'
            requiredMark={false}
        >
            <Form.Item label='Ссылка' name='url'>
                <Input placeholder={'Укажите ссылку перехода пользователя'} />
            </Form.Item>

            <Form.Item name={'image'}>
                <BannerImageUpload
                    isEdit={isEdit}
                    form={form}
                    values={values}
                />
            </Form.Item>
        </Form>
    );
};
